import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "draft-review-modal" };
const _hoisted_2 = {
    class: "relative flex max-h-[92vh] w-[min(96vw,1080px)] flex-col overflow-hidden rounded-xl bg-white shadow-2xl",
    "data-testid": "draft-wizard-modal"
};
const _hoisted_3 = { class: "flex items-center justify-between gap-4 border-b border-gray-200 px-5 py-4" };
const _hoisted_4 = { class: "min-w-0" };
const _hoisted_5 = { class: "text-lg font-semibold text-gray-900" };
const _hoisted_6 = { class: "mt-0.5 text-sm text-gray-500" };
const _hoisted_7 = { class: "sr-only" };
const _hoisted_8 = {
    class: "border-b border-gray-200 bg-white px-5 py-3",
    "data-testid": "draft-wizard-status"
};
const _hoisted_9 = { class: "flex flex-wrap items-center gap-2 text-xs font-semibold" };
const _hoisted_10 = {
    key: 1,
    class: "rounded-full bg-red-100 px-3 py-1 text-red-600"
};
const _hoisted_11 = {
    class: "flex min-h-0 flex-1 flex-col overflow-hidden bg-gray-50",
    "data-testid": "draft-wizard-body"
};
const _hoisted_12 = {
    key: 0,
    class: "min-h-0 flex-1 overflow-y-auto p-5",
    "data-testid": "draft-customer-step"
};
const _hoisted_13 = { class: "mx-auto flex max-w-3xl flex-col gap-4" };
const _hoisted_14 = { class: "rounded-lg border border-orange-200 bg-orange-50 p-4" };
const _hoisted_15 = { class: "text-sm font-semibold text-gray-900" };
const _hoisted_16 = { class: "mt-1 text-sm text-gray-600" };
const _hoisted_17 = { class: "mt-3 rounded-lg bg-white px-3 py-2 text-sm text-gray-800" };
const _hoisted_18 = { class: "font-medium" };
const _hoisted_19 = { class: "grid gap-4 md:grid-cols-[1fr_1.4fr]" };
const _hoisted_20 = { class: "rounded-lg border border-gray-200 bg-white p-4" };
const _hoisted_21 = { class: "text-sm font-semibold text-gray-900" };
const _hoisted_22 = { class: "mt-1 text-xs text-gray-500" };
const _hoisted_23 = { class: "rounded-lg border border-gray-200 bg-white p-4" };
const _hoisted_24 = { class: "text-sm font-semibold text-gray-900" };
const _hoisted_25 = ["placeholder"];
const _hoisted_26 = { class: "mt-3 max-h-64 overflow-y-auto rounded-lg border border-gray-100" };
const _hoisted_27 = {
    key: 0,
    class: "px-3 py-3 text-sm text-gray-500"
};
const _hoisted_28 = ["onClick"];
const _hoisted_29 = { class: "font-medium text-gray-800" };
const _hoisted_30 = { class: "text-xs text-gray-400" };
const _hoisted_31 = {
    key: 1,
    class: "px-3 py-3 text-sm text-gray-500"
};
const _hoisted_32 = {
    key: 1,
    class: "flex min-h-0 flex-1 flex-col overflow-hidden p-4",
    "data-testid": "draft-itinerary-step"
};
import { computed, onMounted, ref } from "vue";
import { IconX } from "@tabler/icons-vue";
import { mapDraftToItinerarySeed, } from "../services/draft-mapping.service";
import LayoutForm from "@/pages/admin/child-pages/Itinerary/components/LayoutForm.vue";
import CustomerModal from "@/pages/admin/child-pages/Itinerary/components/CustomerModal.vue";
import customerRequests from "@/services/admin/customer-service";
import { translateApp } from "@/i18n";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DraftReviewModal',
    props: {
        draft: {}
    },
    emits: ["close", "created"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const layoutForm = ref(null);
        const draftSeed = ref(mapDraftToItinerarySeed(props.draft));
        const hasCustomerStep = !props.draft.customer_id;
        const currentStep = ref(hasCustomerStep ? "customer" : "details");
        const isCustomerModalOpen = ref(false);
        const customers = ref([]);
        const customerSearch = ref("");
        const isLoadingCustomers = ref(false);
        const customerCandidate = computed(() => props.draft.customer_candidate ?? null);
        const needsCustomerResolution = computed(() => currentStep.value === "customer" && !draftSeed.value.customer_id);
        const customerCandidateLabel = computed(() => customerCandidate.value?.full_name || translateApp("chatbot.auto.pending"));
        const customerModalInitialName = computed(() => currentStep.value === "customer" ? customerCandidate.value?.name || "" : "");
        const customerModalInitialLastName = computed(() => currentStep.value === "customer"
            ? customerCandidate.value?.last_name || ""
            : "");
        const filteredCustomers = computed(() => {
            const query = customerSearch.value.trim().toLowerCase();
            const list = customers.value.slice(0, 50);
            if (!query)
                return list;
            return list.filter((customer) => customerDisplayName(customer).toLowerCase().includes(query));
        });
        onMounted(() => {
            if (hasCustomerStep) {
                loadCustomers();
            }
        });
        async function loadCustomers() {
            isLoadingCustomers.value = true;
            try {
                const response = await customerRequests.getAll();
                customers.value = Array.isArray(response.data)
                    ? response.data
                        .map(normalizeCustomer)
                        .filter((customer) => Boolean(customer))
                    : [];
            }
            catch (error) {
                customers.value = [];
            }
            finally {
                isLoadingCustomers.value = false;
            }
        }
        function handleClose() {
            emit("close");
        }
        function handleItineraryCreated(itinerary) {
            if (itinerary?.id != null) {
                emit("created", itinerary.id);
            }
        }
        function handleSaveSuccess() {
            // LayoutForm owns toast and close behavior; this preserves normal form parity.
        }
        function openCustomerModal() {
            isCustomerModalOpen.value = true;
        }
        function handleShowCustomerModal(hidden) {
            isCustomerModalOpen.value = !hidden;
        }
        function handleSetNewCustomer(customer) {
            const normalized = normalizeCustomer(customer);
            if (!normalized)
                return;
            isCustomerModalOpen.value = false;
            if (currentStep.value === "customer") {
                resolveDraftCustomer(normalized);
                currentStep.value = "details";
                return;
            }
            layoutForm.value?.setCustomerSelected?.(normalized);
        }
        function selectExistingCustomer(customer) {
            resolveDraftCustomer(customer);
            currentStep.value = "details";
        }
        function resolveDraftCustomer(customer) {
            draftSeed.value = {
                ...draftSeed.value,
                customer_id: customer.id,
                customer_candidate: null,
            };
        }
        function normalizeCustomer(customer) {
            if (!customer || typeof customer !== "object")
                return null;
            const record = customer;
            const id = Number(record.id);
            if (!Number.isInteger(id) || id <= 0)
                return null;
            return {
                id,
                name: String(record.name ?? ""),
                last_name: record.last_name == null || record.last_name === ""
                    ? ""
                    : String(record.last_name),
                email: record.email == null ? null : String(record.email),
            };
        }
        function customerDisplayName(customer) {
            return [customer.name, customer.last_name].filter(Boolean).join(" ") || `#${customer.id}`;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("header", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t("chatbot.auto.review_ai_draft")), 1),
                            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("chatbot.auto.complete_pending_before_save")), 1)
                        ]),
                        _createElementVNode("button", {
                            type: "button",
                            class: "inline-flex h-9 w-9 items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100",
                            onClick: handleClose
                        }, [
                            _createVNode(_unref(IconX), { size: 18 }),
                            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("chatbot.auto.cerrar")), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            hasCustomerStep
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass(["rounded-full px-3 py-1",
                                        currentStep.value === 'customer'
                                            ? 'bg-eorange-100 text-eorange-700'
                                            : 'bg-green-100 text-green-700'
                                    ])
                                }, " 1. " + _toDisplayString(_ctx.$t("chatbot.auto.step_customer")), 3))
                                : _createCommentVNode("", true),
                            _createElementVNode("span", {
                                class: _normalizeClass(["rounded-full px-3 py-1",
                                    currentStep.value === 'details'
                                        ? 'bg-eorange-100 text-eorange-700'
                                        : 'bg-gray-100 text-gray-600'
                                ])
                            }, _toDisplayString(hasCustomerStep ? "2." : "1.") + " " + _toDisplayString(_ctx.$t("chatbot.auto.step_itinerary")), 3),
                            (needsCustomerResolution.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t("chatbot.auto.customer_pending_short")), 1))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                        (currentStep.value === 'customer')
                            ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, [
                                        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("chatbot.auto.customer_pending_title")), 1),
                                        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("chatbot.auto.customer_pending_description")), 1),
                                        _createElementVNode("div", _hoisted_17, [
                                            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("chatbot.auto.customer_suggested")), 1),
                                            _createTextVNode(" " + _toDisplayString(customerCandidateLabel.value), 1)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_19, [
                                        _createElementVNode("div", _hoisted_20, [
                                            _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("chatbot.auto.create_suggested_customer")), 1),
                                            _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t("chatbot.auto.create_suggested_customer_hint")), 1),
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "mt-4 inline-flex items-center justify-center rounded-lg bg-egreen-500 px-4 py-2 text-sm font-semibold text-white hover:bg-egreen-600",
                                                "data-testid": "create-customer",
                                                onClick: openCustomerModal
                                            }, _toDisplayString(_ctx.$t("chatbot.auto.create_customer")), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_23, [
                                            _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("chatbot.auto.select_existing_customer")), 1),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((customerSearch).value = $event)),
                                                type: "text",
                                                class: "mt-2 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-eorange-300 focus:ring-eorange-300",
                                                placeholder: _ctx.$t('chatbot.auto.search_customer'),
                                                "data-testid": "customer-search"
                                            }, null, 8, _hoisted_25), [
                                                [_vModelText, customerSearch.value]
                                            ]),
                                            _createElementVNode("div", _hoisted_26, [
                                                (isLoadingCustomers.value)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.$t("chatbot.auto.loading_customers")), 1))
                                                    : _createCommentVNode("", true),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCustomers.value, (customer) => {
                                                    return (_openBlock(), _createElementBlock("button", {
                                                        key: customer.id,
                                                        type: "button",
                                                        class: "flex w-full items-center justify-between gap-3 border-b border-gray-100 px-3 py-2 text-left text-sm last:border-b-0 hover:bg-eorange-50",
                                                        "data-testid": "select-existing-customer",
                                                        onClick: ($event) => (selectExistingCustomer(customer))
                                                    }, [
                                                        _createElementVNode("span", _hoisted_29, _toDisplayString(customerDisplayName(customer)), 1),
                                                        _createElementVNode("span", _hoisted_30, "#" + _toDisplayString(customer.id), 1)
                                                    ], 8, _hoisted_28));
                                                }), 128)),
                                                (!isLoadingCustomers.value && filteredCustomers.value.length === 0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.$t("chatbot.auto.no_customers_found")), 1))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ])
                                    ])
                                ])
                            ]))
                            : (_openBlock(), _createElementBlock("section", _hoisted_32, [
                                _createVNode(LayoutForm, {
                                    ref_key: "layoutForm",
                                    ref: layoutForm,
                                    class: "min-h-0 flex-1",
                                    itinerary: null,
                                    "initial-draft": draftSeed.value,
                                    "close-modal": handleClose,
                                    "add-itinerary": handleItineraryCreated,
                                    "handle-show-customer-modal": handleShowCustomerModal,
                                    "wizard-mode": true,
                                    onSaveSuccess: handleSaveSuccess
                                }, null, 8, ["initial-draft"])
                            ]))
                    ]),
                    (isCustomerModalOpen.value)
                        ? (_openBlock(), _createBlock(CustomerModal, {
                            key: 0,
                            "initial-customer-name": customerModalInitialName.value,
                            "initial-customer-last-name": customerModalInitialLastName.value,
                            "handle-show-customer-modal": handleShowCustomerModal,
                            "handle-set-new-customer": handleSetNewCustomer
                        }, null, 8, ["initial-customer-name", "initial-customer-last-name"]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
